import React, { FC, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/rootReducer';
import { formatNumberWithCurrencySymbol } from '../../../util';
import { NA, NACaps } from '../../../util/strings';
import TravelDateInfo from '../../common/TravelDateInfo/TravelDateInfo';
import withLocalization from '../../hoc/withLocalization';

const PackagePrice: FC<any> = (props: any): ReactElement => {
  const { localize } = props;
  const availabilityDates = useSelector((state: RootState) => state.availabilityDates);
  const openDateSelector = availabilityDates.openDateSelector;
  const offerDetails = useSelector((state: RootState) => state.offerDetails);
  const selectedRoom = offerDetails.selectedRoomType;
  const offer = offerDetails.currentOffer;
  const selectedDate = availabilityDates.finalSelectedDate;

  let extraNights = availabilityDates.finalSelectedExtraNights;
  extraNights = extraNights ? extraNights : 0;
  const lowSeasonCost: string = selectedRoom?.startingCost ? selectedRoom?.startingCost : '';
  const highSeasonCost: string = selectedRoom?.highSeasonCost ? selectedRoom?.highSeasonCost : '';
  const isLowSeasonPriceNotValid = lowSeasonCost.toLowerCase() === '' || lowSeasonCost.toLowerCase() === NA;
  const isHighSeasonPriceNotValid = highSeasonCost.toLowerCase() === '' || highSeasonCost.toLowerCase() === NA;

  const depositLabel = (
    <div>
      <hr />
      <p>
        <span className="bolderText">
          {localize('preview-sales-engine.static-content.copy.package-summary-component.deposit-label')}
        </span>
        <span className="floatRight">
          {selectedRoom && selectedRoom.depositAmount ? selectedRoom.depositAmount : 0}
        </span>
      </p>
    </div>
  );

  const renderForSamePrice = <span className="floatRight">{selectedRoom && lowSeasonCost ? lowSeasonCost : 0}</span>;

  const onlyOnePricePresent = (
    <span className="floatRight">{selectedRoom && !isLowSeasonPriceNotValid ? lowSeasonCost : highSeasonCost}</span>
  );

  const bothPricePresent = (
    <div className="">
      <p>
        <span className="bolderText">
          {localize('preview-sales-engine.static-content.copy.package-summary-component.low-season-price')}{' '}
        </span>
        <span className="floatRight">
          {selectedRoom && lowSeasonCost && !isLowSeasonPriceNotValid ? lowSeasonCost : NACaps}
        </span>
      </p>
      <p>
        <span className="bolderText">
          {localize('preview-sales-engine.static-content.copy.package-summary-component.high-season-price')}{' '}
        </span>
        <span className="floatRight">
          {selectedRoom && highSeasonCost && !isHighSeasonPriceNotValid ? highSeasonCost : NACaps}
        </span>
      </p>

      <TravelDateInfo
        lowSeasonDateRanges={offer?.lowSeasonDateRanges}
        highSeasonDateRanges={offer?.highSeasonDateRanges}
        placement="top"
      />
      {depositLabel}
    </div>
  );

  const notOpenDated = (
    <div className="priceWrapper">
      <p>
        <span className="bolderText">
          {localize('preview-sales-engine.static-content.copy.package-summary-component.base-price-label')}{' '}
        </span>
        <span className="floatRight">
          {formatNumberWithCurrencySymbol(selectedDate && selectedDate.basePrice ? selectedDate.basePrice : 0)}
        </span>
      </p>
      <p>
        <span className="bolderText">
          {localize('preview-sales-engine.static-content.copy.package-summary-component.surcharge-labe')}{' '}
        </span>
        <span className="floatRight">
          {formatNumberWithCurrencySymbol(
            selectedDate && selectedDate.holidaySurcharge ? selectedDate.holidaySurcharge : 0,
          )}
        </span>
      </p>
      {extraNights > 0 ? (
        <p>
          <span className="bolderText">
            {localize('preview-sales-engine.static-content.copy.Labels.labels#additional-night-charge')}
          </span>
          <span className="floatRight">
            {formatNumberWithCurrencySymbol(
              selectedDate && selectedDate.additionalNightCharge ? selectedDate.additionalNightCharge : 0,
            )}
          </span>
        </p>
      ) : (
        <></>
      )}
      <hr />
      <p>
        <span className="bolderText">
          {localize('preview-sales-engine.static-content.copy.package-summary-component.total-package-price-label')}
        </span>
        <span className="floatRight">
          {formatNumberWithCurrencySymbol(selectedDate && selectedDate.totalCost ? selectedDate.totalCost : 0)}
        </span>
      </p>
    </div>
  );

  const onePriceCondition = isLowSeasonPriceNotValid || isHighSeasonPriceNotValid;

  return (
    <>
      {openDateSelector ? (
        lowSeasonCost === highSeasonCost ? (
          <div>
            <p>
              <span className="bolderText ">
                {localize('preview-sales-engine.static-content.copy.package-summary-component.package-price-header')}:
              </span>
              {renderForSamePrice}
            </p>
            {depositLabel}
          </div>
        ) : onePriceCondition ? (
          <div>
            <p>
              <span className="bolderText ">
                {localize('preview-sales-engine.static-content.copy.package-summary-component.package-price-header')}:
              </span>
              {onlyOnePricePresent}
            </p>
            {depositLabel}
          </div>
        ) : (
          <div>{bothPricePresent}</div>
        )
      ) : (
        <div>{notOpenDated}</div>
      )}
    </>
  );
};
export default withLocalization(PackagePrice);
